module.exports = __webpack_public_path__ + "static/quiver_of_ehlonna-105ded7e64403088559c5d815581feaf.jpeg";